import axiosInstance from "@/api/axiosInstance";
import { DiagnosticCompanyRow } from "@/modules/growthStages/features/Diagnostics/types/diagnostic";

/** Companies that already have at least one diagnostic on record. */
export const listDiagnosticCompanies = async (): Promise<
  DiagnosticCompanyRow[]
> => {
  const response = await axiosInstance.get<{
    companies: DiagnosticCompanyRow[];
  }>("/api/private/diagnostics/companies");
  return response.data.companies;
};

export interface SelectableCompany {
  companyId: number;
  name: string;
}

/** Every company, for the "new diagnostic" picker. */
export const listSelectableCompanies = async (): Promise<
  SelectableCompany[]
> => {
  const response = await axiosInstance.get<{ companies: SelectableCompany[] }>(
    "/api/private/diagnostics/companies/selectable",
  );
  return response.data.companies;
};
